import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectCurrentUser,
  selectUserPermissions,
  getAuthRoleName,
  AuthRole,
} from '../redux/slices/auth.slice';

function isPlatformAdminRole(roles?: AuthRole[]): boolean {
  return roles?.some((r) => getAuthRoleName(r)?.trim().toLowerCase() === 'admin') ?? false;
}

/**
 * True when the user may pick any branch in inventory filters (gestión en sucursal).
 * Platform admin: full bypass. Everyone else: only with canSellFromOtherLocations flag.
 * Mirrors warehouse-inventory-products.controller canUseAnyLocationFilter.
 */
export function useCanChangeInventoryLocation(): boolean {
  const currentUser = useSelector(selectCurrentUser);
  const userPermissions = useSelector(selectUserPermissions);

  return useMemo(() => {
    if (!currentUser) return false;
    if (userPermissions.includes('*.*.*')) return true;
    if (isPlatformAdminRole(currentUser.roles)) return true;
    return currentUser.canSellFromOtherLocations === true;
  }, [currentUser, userPermissions]);
}
